import React from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from '@billda/design-system';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
  error?: string | null;
  'data-testid'?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  loading = false,
  error,
  'data-testid': dataTestId = 'confirm-dialog',
}) => (
  <Dialog
    open={open}
    onOpenChange={next => {
      if (!next && !loading) {
        onCancel();
      }
    }}
  >
    <DialogContent data-testid={dataTestId}>
      <DialogHeader data-testid="confirm-dialog-title">{title}</DialogHeader>
      <DialogBody
        data-testid="confirm-dialog-message"
        className="text-content-secondary"
      >
        {message}
      </DialogBody>
      {error ? (
        <Alert severity="error" className="mt-4">
          {error}
        </Alert>
      ) : null}
      <DialogFooter>
        <Button
          variant="ghost"
          onClick={onCancel}
          disabled={loading}
          data-testid="confirm-dialog-cancel"
        >
          {cancelText}
        </Button>
        <Button
          variant="danger"
          onClick={onConfirm}
          loading={loading}
          data-testid="confirm-dialog-confirm"
        >
          {confirmText}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default ConfirmDialog;
